import { Link } from 'react-router-dom';
import styled from 'styled-components';
import TechStackBadge from '@/components/TechStackBadge';
import UserInitials from '@/trio-ui/UserInitials';

export const CustomTechStackBadge = styled(TechStackBadge)`
  display: inline-block;
  &:not(:last-of-type) {
    margin-right: 6px;
  }
`;

export const CustomUserInitials = styled(UserInitials)`
  width: 24px;
  height: 24px;
  margin-right: 12px;
  font-size: 9px;
`;

export const Content = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    .chakra-table__container {
      max-height: calc(100vh - 230px);
      overflow-y: scroll;
    }
  }
`;

export const TableLink = styled(Link)`
  color: ${(props) => props.theme.colors['primary-60']};
  font-weight: 600;
`;

export const Centered = styled.div`
  display: flex;
  align-items: center;
`;

export const NotFound = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #fff;
  height: 410px;
  color: ${(props) => props.theme.colors['neutral-100']};
  p {
    margin-bottom: 24px;
  }
`;

export const NotFoundSubtitle = styled.p`
  font-size: 26px;
  line-height: 30px;
  font-weight: 600;
  color: ${(props) => props.theme.colors['neutral-50']};
`;
